export const EXTENSION_JPEG = 'jpeg'
export const EXTENSION_PNG = 'png'
export const EXTENSION_SVG = 'svg'

export const extensionOptions = [
  { label: EXTENSION_JPEG.toUpperCase(), value: EXTENSION_JPEG },
  { label: EXTENSION_PNG.toUpperCase(), value: EXTENSION_PNG },
  { label: EXTENSION_SVG.toUpperCase(), value: EXTENSION_SVG }
]
